import React from 'react'
import PropTypes from 'prop-types'

import './Wasteland.css'

const CLASS = 'insights-wasteland'

const Wasteland = props => {
  const className = props.className || CLASS
  return <div className={className}>{props.children}</div>
}

Wasteland.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
}

export default Wasteland
